/*
  IMPORTANT: This file is modified to suit other behaviour than actual IP redirect.
*/
(function($, document, window, undefined) {
  window.IPRedirect = {
    init: function(settings) {
      // Assignment
      var self = this;
      self.settings = settings;
      self.messageWrap = $("#new-location-redirect-message");
      self.messageInternational = $('.message-international', self.messageWrap);
      self.messageAU = $('.message-au', self.messageWrap);
      self.domain = "https://reallyfreegeoip.org/json/?callback=?";

      return true;
    },
    run: function() {
      var self = this,
          successCallback = self.fetchAndShowRedirect;

      self.makeServerCall( self.fetchLocationInfoAndRunCallback, successCallback );

    },
    makeServerCall: function( serverCall, callback ) {
      return serverCall(callback);
    },
    fetchLocationInfoAndRunCallback: function( successCallback ) {
      var self = IPRedirect;

      $.ajax( {
        url: self.domain,
        type: 'POST',
        dataType: 'jsonp',
        async: false,
        success: function(location) {
          successCallback(location);
          if (self.settings.callbacks && self.settings.callbacks.length > 0) {
            for (var i = 0; i < self.settings.callbacks.length; ++i) {
              self.settings.callbacks[i].call(self, location);
            }
          };
        },
        error: successCallback
      });
    },
    fetchAndShowRedirect: function( location ) {
      $('body').addClass(location.country_code);
      var self = IPRedirect,
          countryCode = location.country_code,
          showMessageWrap = false;

//       if( countryCode === "AU" ) {
//         self.messageAU.show();
//         self.messageInternational.hide();
//         showMessageWrap = true;
        
//       } else {
//         self.messageInternational.show();
//         self.messageAU.hide();
//         showMessageWrap = true;
//       }

//       if( showMessageWrap )
//         self.messageWrap.show();
    }
  };
})(jQuery, document, window);